/*
 * Copyright (C) 2025 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { i18n, init as initI18n } from '@coop/localization';
import { Spinner } from '@coop/ole/Spinner';
import { configureScope, init } from '@sentry/browser';
import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyles from './globalStyles';
import { Routes } from './routes';
import { v4 as uuidv4 } from 'uuid';
import { SENTRY_DSN, SENTRY_ENVIRONMENT, SENTRY_RELEASE } from './env';
import { I18nProvider } from '@lingui/react';

init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  release: SENTRY_RELEASE
});
initI18n();

configureScope((scope) => scope.setUser({ id: uuidv4() }));

export const Home = () => {
  return (
    <>
      <GlobalStyles />
      <Routes />
    </>
  );
};

async function loadCatalogForLanguage(language: string) {
  return await import(
    /* webpackMode: "lazy", webpackChunkName: "locale-self-referral-[index]" */
    `@lingui/loader!./locales/${language}/messages.po`
  );
}

(async () => {
  const initialLanguage = 'en-US';
  const initialCatalog = await loadCatalogForLanguage(initialLanguage);
  i18n.load({ [initialLanguage]: initialCatalog.messages });
  i18n.activate(initialLanguage);

  const view = (
    <I18nProvider i18n={i18n}>
      <BrowserRouter>
        <React.Suspense fallback={<Spinner copy="Loading..." />}>
          <Home />
        </React.Suspense>
      </BrowserRouter>
    </I18nProvider>
  );
  render(view, document.getElementById('root'));
})();
